<template>
	<div class="flex flex-col c-box"  @click.stop>
		<div class="header-box">
			<p style="width: 90%; margin: 0 auto"  :title="preViewData.zpname" class="nowrap">
				{{ preViewData.zpname  }}
			</p>
			<div class="close-box" @click="closePreview">×</div>
		</div>
		<div class="centent-box">
			 <div  class="box-item" v-for="item in list">
			   <a-descriptions title="" :column="2" bordered>
				    <a-descriptions-item label="评审人">
				       {{item.expertName}}
				    </a-descriptions-item>
				     <a-descriptions-item label="评审时间">
			           {{item.suggestionTime}}  
			     </a-descriptions-item>
			      <a-descriptions-item label="评审意见">
			           <div style="white-space:pre-line;line-height:20px;" v-html="item.suggestion"></div>
			     </a-descriptions-item>
			  </a-descriptions>
   		    </div>
	  </div>
</div>
</template>

<script>
	import { getSuggestion } from '@/api/index';
	export default {
		name: "",
		props: {
			preViewData: {
				type: Object,
			},
			expertUserId:{
				type:String,
				default:'',
			},
		},
		data() {
			return {
				list:[],
//				list:[{expertName:'张三',suggestionTime:'2023-12-12',suggestion:'非常不错，继续加油'},{expertName:'里斯',suggestionTime:'2023-11-12',suggestion:'都是非常不错，继续加油'}],
			};
		},
		computed: {},
		watch: {},
		created() {},
		mounted() {
			this.getRef();
		},
		methods: {
			getRef(){
			       var data = {
            		applyId: this.preViewData.id,
				   };
				   if(this.expertUserId!=''){
				   	data.expertUserId=this.expertUserId;
				   }
		           getSuggestion(data).then((res) => {
		            if (res.code == 200) {
		               this.list=res.result;
		               for(var i=0; i<this.list.length;i++){
		               	if(this.list[i].suggestion!=''){
		               		  this.list[i].suggestion=String(this.list[i].suggestion).replaceAll("\\n","\n");
		               	}
		               }
		            }
		          });
			},
			closePreview() {
				this.$emit("closePreview");
			},
		},
	};
</script>

<style scoped lang="scss">
	.img-box {
		width: 15px;
		height: 17px;
		margin-right: 8px;
	}
	
	.img-box-min {
		width: 10px;
		height: 12px;
		margin-right: 8px;
	}
	
	.c-box {
		width: 100%;
		height: 100%;
		background: url("../../assets/images/img19.png") no-repeat;
		background-size: 100% 100%;
	}
	
	.c-box-fullscreen {
		width: 100%;
		height: 100%;
		background: #fff;
		/* background: url("../../assets/images/img19.png") no-repeat;
  background-size: 100% 100%;*/
	}
	
	.header-box-fullscreen {
		height: 80px;
		line-height: 78px;
		position: relative;
		text-align: center;
		background: #9A0B00;
		font-size: 28px;
		font-family: Microsoft YaHei;
		font-weight: bold;
		color: #fff;
	}
	
	.header-box {
		height: 80px;
		line-height: 78px;
		position: relative;
		text-align: center;
		background: #9A0B00;
		border-top-left-radius: 15px;
		border-top-right-radius: 15px;
		margin: 0px 19px 0px 9px;
		font-size: 28px;
		font-family: Microsoft YaHei;
		font-weight: bold;
		color: #fff;
	}
	
	.centent-box {
		margin: 0 12px 5px 0;
		padding: 10px 25px;
		height: 80%;
		overflow: auto;
		.box-item{
			margin:20px auto;
			/deep/ .ant-descriptions-item-label{
				width:120px;
			}
			/deep/ .ant-descriptions-item-content{
				width:240px;
			}
		}
    }
	.close-box {
		position: absolute;
		color: #fff;
		font-size: 40px;
		right: 3%;
		cursor: pointer;
		top: -2px;
	}
		
</style>